const isPrimitive = value => typeof value !== 'object' && typeof value !== 'function' || value === null;
export default isPrimitive;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/isPrimitive.js
// module id = 1695
// module chunks = 0